import { Component, EventEmitter, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import imageCompression from 'browser-image-compression';

@Component({
    selector: 'app-image-selector',
    templateUrl: './image-selector.component.html',
    styleUrls: ['./image-selector.component.scss'],
    standalone: false
})
export class ImageSelectorComponent {
  @Output() imageSelected = new EventEmitter<any>();

  constructor(private sanitizer: DomSanitizer) {}

  async handleImageUpload(event: any) {
    const imageFile = event.target.files[0];
    if (!imageFile) return;

    const options = {
      maxSizeMB: 3,
      maxWidthOrHeight: 800,
      useWebWorker: true
    };

    try {
      await imageCompression(imageFile, options).then(output => {
        const imageObject = {
          data: output,
          img: this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(output)),
          old: false
        };
        this.imageSelected.emit(imageObject);
      });
    } catch (error) {
      console.error('Error compressing image:', error);
    }

    event.target.value = ''; // Reset the input to ensure it triggers a change event next time
  }
}
